<template>
  <v-dialog v-model="showDialog" persistent max-width="400">
    <v-card class="pa-3">
      <v-card-title class="pb-0">
        <div class="title font-weight-bold mx-auto">
          Deseja faturar unificado?
        </div>
      </v-card-title>
      <v-card-text class="mx-auto py-0">
        <v-flex xs12 md12 class="mx-auto d-flex justify-center">
          <v-radio-group v-model="unifiedOption" row class="options">
            <v-radio label="Sim" value="yes"></v-radio>
            <v-radio label="Não" value="no"></v-radio>
          </v-radio-group>
        </v-flex>
        <transition name="slide-fade">
          <v-flex v-show="unifiedOption === 'yes'" xs12 md12>
            <v-form ref="billing_form" v-model="valid" lazy-validation>
              <v-text-field
                v-model="billing_data.total_invoice"
                label="Valor da Concessionária"
                required
                :rules="[(v) => !!v || 'Por favor, informe o valor.']"
                type="number"
                class="pt-0"
                prefix="R$"
              ></v-text-field>
              <v-text-field
                v-model="billing_data.cod_boleto"
                label="Código de barras"
                required
                type="text"
                :rules="[
                  (v) => !!v || 'Por favor, informe o código de barras.',
                ]"
              ></v-text-field>
              <v-text-field
                v-model="billing_data.due_date_utility"
                label="Data de vencimento da Concessionária"
                required
                :rules="[
                  (v) => !!v || 'Por favor, informe a data de vencimento.',
                ]"
                class="mb-2"
                type="date"
              ></v-text-field>
              <v-flex xs12>
                <v-text-field
                  label="Segunda Via (simplificada)"
                  prepend-icon="attach_file"
                  @click="pickBillFile"
                  v-model="filename"
                ></v-text-field>
                <input
                  style="display: none"
                  @change="detectFiles($event)"
                  accept="application/pdf"
                  type="file"
                  ref="billFile"
                />
              </v-flex>
              <v-text-field
                v-model="password"
                label="Senha do PDF (caso aplicável)"
                type="text"
              ></v-text-field>
            </v-form>
          </v-flex>
        </transition>
      </v-card-text>
      <v-card-actions>
        <div class="mx-auto">
          <v-btn color="primary" text @click="closeModal" :disabled="loading"
            >Fechar</v-btn
          >
          <v-btn
            color="pink darken-1"
            text
            @click="confirm"
            :loading="loading"
            :disabled="!permissions.invoice_by_spreadsheet"
            >Confirmar</v-btn
          >
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import axios from "axios";
import { mapState } from "vuex";
import { mapActions } from "vuex";
import moment from "moment";
import { getPermission } from "../../services/permissions";

export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },

    closeBillingModal: {
      type: Function,
      required: true,
    },

    selectedBill: {
      type: Object,
      required: false,
    },
  },

  data() {
    return {
      valid: false,
      unifiedOption: "no",
      billing_data: {
        total_invoice: null,
        cod_boleto: null,
        due_date_utility: null,
      },
      filename: "",
      password: "",
      loading: false,
    };
  },

  async mounted() {
    const info_payments = await this.getInfoPayments({
      competence: this.selectedBill?.competence,
      consumer_unit: this.selectedBill?.consumer_unit,
    });
    if (info_payments) {
      this.billing_data.total_invoice = info_payments?.total_utility;
      this.billing_data.cod_boleto = info_payments?.barcode;
      this.billing_data.due_date_utility = moment(
        info_payments?.due_date,
        "DD/MM/YYYY",
      )?.format("YYYY-MM-DD");
    }
  },

  computed: {
    ...mapState(["user", "permissions"]),
  },

  methods: {
    ...mapActions("billing", ["getInfoPayments"]),
    async confirm() {
      try {
        this.loading = true;
        const permission = await getPermission(
          "invoice_by_spreadsheet",
          this.user.id,
        );

        if (!permission.data.has_permission) {
          this.$emit(
            "showSnack",
            "Usuário sem permissão para realizar essa ação",
            "red",
          );
          this.loading = false;
          return false;
        }
      } catch (err) {
        this.loading = false;
        this.$emit(
          "showSnack",
          "Falha ao consultar permissão do usuário",
          "red",
        );
        console.error("Falha ao consultar permissão", err);
        return false;
      }

      if (this.unifiedOption == "yes") {
        if (this.$refs.billing_form.validate()) {
          this.$emit(
            "checkBillingOptition",
            this.unifiedOption,
            this.billing_data,
          );
        }
      } else {
        this.$emit(
          "checkBillingOptition",
          this.unifiedOption,
          this.billing_data,
        );
      }

      this.loading = false;
    },

    async detectFiles(e) {
      let files = e.target.files;
      if (!files || files.length == 0) return;
      const file = files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = async (e) => {
          const fileData = e.target.result;
          const base64 = fileData.split("base64,")[1];
          if (base64) {
            try {
              const res = await axios.post("api/v1/bill/simplifiedinfo", {
                base64: base64,
                password: this.password !== "" ? this.password : null,
              });
              this.billing_data.total_invoice = res.data.value
                ? res.data.value
                : null;
              this.billing_data.cod_boleto = res.data.barcode
                ? res.data.barcode
                : null;
              this.billing_data.due_date_utility = res.data.due_date
                ? this.toISODate(res.data.due_date)
                : null;
            } catch (err) {
              console.error(err);
            }
          }
        };
        reader.readAsDataURL(file);
        this.filename = file.name;
      }
    },

    toISODate(date) {
      let splitted = date.split("/");
      return `${splitted[2]}-${splitted[1]}-${splitted[0]}`;
    },

    pickBillFile() {
      this.$refs.billFile.click();
    },

    closeModal() {
      this.closeBillingModal();
    },
  },
};
</script>
<style lang="scss">
.slide-fade-enter-active {
  transition: all 0.4s ease;
}

.slide-fade-enter {
  transform: translateY(10px);
  opacity: 0;
}

.options {
  max-width: fit-content !important;
}
</style>
